import { Stack } from '@/components/layout';
import { AppHeader } from '@/components/layout/app-header';
import { SvgIcon } from '@/components/ui/svg-icon';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks/use-scaling';
import { AuthStackParamList } from '@/navigations/types';
import { colors } from '@/theme/colors';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

// Header
export function DetailCoachHeader() {
  const styles = useStyles();
  const navigation = useNavigation<NativeStackNavigationProp<AuthStackParamList>>();
  const insets = useSafeAreaInsets();
  const { scale, isTablet } = useScaling();

  return (
    <AppHeader
      paddingTop={insets.top + scale({ phone: 12, tablet: 21 })}
      paddingBottom={scale({ phone: 15, tablet: 21 })}
      backgroundColor="white">
      <AppHeader.Left>
        <TouchableOpacity
          style={styles.headerButton}
          onPress={() => {
            navigation.goBack();
          }}>
          <Stack direction="row" align="center" gap={scale(2)}>
            <SvgIcon name="IcBackBlue" size={24} />
            <Text
              variant={isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Medium'}
              style={styles.headerActionText}>
              {STRINGS.coachProfile.header.back}
            </Text>
          </Stack>
        </TouchableOpacity>
      </AppHeader.Left>
      <AppHeader.Title>
        <Text
          variant={
            isTablet
              ? 'Font Inter/Subtitle/Bold 14px'
              : 'Font Montserrat/Subtitle/Minimize 1 Bold 11px'
          }
          fontWeight={isTablet ? undefined : '800'}
          style={styles.headerTitle}>
          {STRINGS.coachProfile.header.title}
        </Text>
      </AppHeader.Title>
      <AppHeader.Right>
        <TouchableOpacity
          style={styles.headerButton}
          onPress={() => {
            navigation.navigate('MutateCoachProfile');
          }}>
          <Stack direction="row" align="center" gap={scale(2)}>
            <Text
              variant={isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Medium'}
              style={styles.headerActionText}>
              {STRINGS.coachProfile.header.edit}
            </Text>
            <SvgIcon name="IcEdit" size={24} color={colors.Blue} />
          </Stack>
        </TouchableOpacity>
      </AppHeader.Right>
    </AppHeader>
  );
}

const useStyles = createStyles(({ scale }) => ({
  //Header
  headerTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  divider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['6'],
  },
  headerButton: {
    paddingHorizontal: scale(4),
  },
  headerActionText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
}));
